module.exports = __webpack_public_path__ + "img/german-caldeiro.0aa2abe7.jpg";